import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Star, Users, Book, Gift } from 'lucide-react';
const testimonials = [{
  initials: 'MG',
  name: 'Marcela G., Córdoba',
  role: 'Contadora Independiente',
  text: 'Organicé todo el sistema de mi estudio en una semana. Los prompts de ARCA me ahorran 3 horas por semana solo en circulares.',
  color: 'bg-blue-500'
}, {
  initials: 'LP',
  name: 'Laura P., Rosario',
  role: 'Estudio Contable Unipersonal',
  text: 'El protocolo de honorarios del Tomo 4 me dio el guión exacto para subir mis abonos un 70%. Ningún cliente se fue.',
  color: 'bg-emerald-500'
}, {
  initials: 'RM',
  name: 'Roberto M., Buenos Aires',
  role: 'Contador PyME',
  text: 'La macro de liquidación de IVA del Tomo 3 hace en 8 segundos lo que me llevaba 45 minutos. No lo podía creer.',
  color: 'bg-purple-500'
}];
export function SocialProof() {
  return <section className="py-16 bg-brand-darker border-y border-slate-800/50" data-id="element-285">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-286">
        <FadeIn data-id="element-287">
          <div className="text-center mb-12" data-id="element-288">
            <h3 className="text-brand-accent font-bold tracking-widest uppercase text-sm mb-2" data-id="element-289">
              Prueba Social
            </h3>
            <h2 className="text-3xl font-bold" data-id="element-290">Lo que dicen los contadores</h2>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-6 mb-16" data-id="element-291">
          {testimonials.map((t, i) => <FadeIn key={i} delay={i * 0.1} className="bg-brand-card border border-slate-800 p-6 rounded-2xl relative" data-id="element-292">
              <div className="flex items-center gap-1 mb-4" data-id="element-293">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-brand-accent text-brand-accent" data-id="element-294" />)}
              </div>
              <p className="text-slate-300 mb-6 italic" data-id="element-295">"{t.text}"</p>
              <div className="flex items-center gap-3 mt-auto" data-id="element-296">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold text-white ${t.color}`} data-id="element-297">
                  {t.initials}
                </div>
                <div data-id="element-298">
                  <div className="font-bold text-sm" data-id="element-299">{t.name}</div>
                  <div className="text-xs text-slate-400" data-id="element-300">{t.role}</div>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-301">
          <div className="flex flex-wrap justify-center gap-8 md:gap-16 text-center border-t border-slate-800/50 pt-10" data-id="element-302">
            <div data-id="element-303">
              <div className="flex items-center justify-center gap-2 text-3xl font-bold text-white mb-1" data-id="element-304">
                <Users className="w-6 h-6 text-brand-accent" data-id="element-305" /> +500
              </div>
              <div className="text-sm text-slate-400" data-id="element-306">contadores confían</div>
            </div>
            <div data-id="element-307">
              <div className="flex items-center justify-center gap-2 text-3xl font-bold text-white mb-1" data-id="element-308">
                <Book className="w-6 h-6 text-brand-accent" data-id="element-309" /> 6
              </div>
              <div className="text-sm text-slate-400" data-id="element-310">Tomos listos</div>
            </div>
            <div data-id="element-311">
              <div className="flex items-center justify-center gap-2 text-3xl font-bold text-white mb-1" data-id="element-312">
                <Gift className="w-6 h-6 text-brand-accent" data-id="element-313" /> 4
              </div>
              <div className="text-sm text-slate-400" data-id="element-314">Bonos incluidos</div>
            </div>
            <div data-id="element-315">
              <div className="flex items-center justify-center gap-2 text-3xl font-bold text-white mb-1" data-id="element-316">
                <Star className="w-6 h-6 text-brand-accent fill-brand-accent" data-id="element-317" />{' '}
                4.9/5
              </div>
              <div className="text-sm text-slate-400" data-id="element-318">calificación ⭐</div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}